import { createContext, useContext } from 'react';

/**
 * Demo-only override. When true, every occupied seat renders its dealer chip
 * (instead of just the seat matching `game.dealer`), so the dealer-button
 * placement can be eyeballed at every seat at once. Production code never
 * provides this, so it stays false and has no effect.
 */
export const ShowAllDealersContext = createContext(false);

export const useShowAllDealers = () => useContext(ShowAllDealersContext);
